import { type FC } from 'react';
import CollectionTagItem from 'components/CollectionTag';
import { RouteTypes } from 'RouteTypes';
import { type CollectedByProps } from './types';
import {
  CollectedByHead,
  CollectedByWrapper,
  CollectedByBackground,
  CollectedByCol,
  CollectedByAvatar,
  CollectedByName,
  CollectedByTitle,
  CollectorTagWrapper,
} from './styled';

const CollectedBy: FC<CollectedByProps> = ({
  avatar,
  background,
  name,
  title,
  username,
  colId,
  children,
  tags,
}) => (
  <CollectedByWrapper data-test-id="collected_by_wrapper">
    <CollectedByHead data-test-id="collected_by_header">
      <CollectedByBackground data-test-id="collected_by_background" media={background} lazy />
      <CollectedByCol data-test-id="collected_by_col" as="a" href={username && RouteTypes.User.replace(':username', username)}>
        <CollectedByAvatar data-test-id="collected_by_avatar" media={avatar} />
      </CollectedByCol>
      <CollectedByCol>
        <CollectedByName data-test-id="collected_by_name" to={(username && RouteTypes.User.replace(':username', username)) || ''}>
          {name}
        </CollectedByName>
        <CollectedByTitle
          data-test-id="collected_by_title"
          to={(username && RouteTypes.Collection.replace(':username', username).replace(':collectionId', colId)) || ''}
        >
          {title}
        </CollectedByTitle>
        <CollectorTagWrapper data-test-id="collected_tag_wrapper">
          {(tags || []).map((item) => (
            <CollectionTagItem item={item.rarity} number={item.number} key={item.rarity} />
          ))}
        </CollectorTagWrapper>
      </CollectedByCol>
    </CollectedByHead>
    {children}
  </CollectedByWrapper>
);

export default CollectedBy;
